import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { handleErrorsForSSO } from './identityService';
import { SsoType } from '../utils/costanti';

export const ticketService = (ip: string, authData: AuthDataType, user: User, id: string, url?: string, prov?: string | null, uffi?: string | null, nome?: string, sso?: SsoType) => {
    
    let urlCalled = `${process.env.REACT_APP_AUTH_AUTHORITY}ticket?appl=${id}&url=${url}&prov=${prov}&uffi=${uffi}&sso=${sso}`;
    console.log('end point in service url: ' + urlCalled);
    return window.fetch(urlCalled, 
    {
        method: 'GET',
        headers: getHeadersEasyStart(ip, user.access_token, user)
        // body: JSON.stringify(user.access_token)
    })
    .then(res => handleErrorsForSSO(res))
    .then(res => res.json())
    .then(obj => {
        console.log('Authentication ticket ok');
        if (obj.status === 'Error') {
            throw new Error(obj.message);
        } else {
            return obj;
        }
    })
    .catch((e: any) => {
        console.log('Authentication Ticket failed');
        console.log('Authentication Ticket : ' + user.access_token);
        console.log('Authentication Ticket error: ' + e.message);
        console.log('Authentication Ticket authData: ' + JSON.stringify(authData));
        console.error(e.message, { 
            app: nome, 
            guid: id,
            url: url,
            prov: prov,
            uffi: uffi,
            authData: authData
        });
        return {};
    })
}

export function getHeadersEasyStart(ip: string, access_token: string, user: User): Headers {

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append("Access-Control-Allow-Credentials", 'true');
    // headers.append('Authorization', access_token);
    headers.append('IP', ip);
    
    headers.append("Authorization", `Bearer ${user.access_token}`);
    // user && headers.append("Authorization", `${user.access_token}`);
    return headers;
}
